export default __webpack_public_path__ + "93eb46d585759660fa131ea71ab314f3.png";